<template>
  <div class="page">
    <!-- 返回按钮 -->
    <div  class="back" >
      <img v-if="isLargeScreen" @click="router.go(-1)" :src="back" alt="back">
      <span v-if="isLargeScreen" @click="router.go(-1)" >{{ t('common.back') }}</span>
    </div>

    <div class="content" >
      <div class="title">{{ detail.title }}</div>
      <div class="text">
        <!-- 遍历富文本内容 -->
        <div v-for="(block, index) in detail.content" :key="index">
          <!-- 标题 -->
          <component v-if="block.type === 'heading'" :is="'h' + block.level">
            <span v-for="(child, idx) in block.children" :key="idx">
              {{ child.text }}
            </span>
          </component>

          <!-- 段落 -->
          <p v-else-if="block.type === 'paragraph'">
            <span v-for="(child, idx) in block.children" :key="idx" :style="{ fontWeight: child.bold ? 'bold' : 'normal' }">
              {{ child.text }}
              <br v-if="child.text==''" />
            </span>
          </p>

          <!-- 图片 -->
          <div v-else-if="block.type === 'image'" class="image-container">
            <img :src="block.url" :alt="block.alt || '图片'" />
          </div>

          <!-- 有序列表 -->
          <ol v-else-if="block.type === 'list' && block.ordered">
            <li v-for="(item, idx) in block.children" :key="idx">
              <span v-for="(child, i) in item.children" :key="i">{{ child.text }}</span>
            </li>
          </ol>

          <!-- 无序列表 -->
          <ul v-else-if="block.type === 'list' && !block.ordered">
            <li v-for="(item, idx) in block.children" :key="idx">
              <span v-for="(child, i) in item.children" :key="i">{{ child.text }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div v-if="!isLargeScreen">
    <!-- 其他内容 -->
    <WritingSkillPage />
    <!-- 其他内容 -->
  </div>
</template>

<script setup>
  import { getWritingSkillDetail } from "@/api/api";
  import back from '../assets/list/back.png'
  import i18n from '../locale/i18n';
  import { useRouter, useRoute } from 'vue-router';
  import { useHead } from '@vueuse/head';
  import { ref, inject, onMounted } from 'vue';
  import WritingSkillPage from '../components/moreWritingSkill.vue';

  const t = (key) => i18n.global.t(key);
  const router = useRouter();
  const route = useRoute();
  const detail = ref({});
  const lineIndex = ref(0);

  const isLargeScreen = ref(true);
  if (typeof window !== 'undefined') {
    isLargeScreen.value = window.innerWidth > 768;
    // Watch for screen size change
    window.addEventListener('resize', () => {
      isLargeScreen.value = window.innerWidth > 768;
    });
  }

  // 服务器端数据获取
  if (import.meta.env.SSR) {
    const initialState = inject('initialState');
    const data = initialState?.data || {};
    detail.value = data;
    useHead({
      htmlAttrs: { lang: data.locale },
      title: data.title,
      meta: [
        { name: 'description', content: data.description },
        { name: 'keywords', content: data.keywords },
      ],
    });
  } else {
    // 客户端数据获取
    onMounted(async () => {
      try {
        const res = await getWritingSkillDetail(route.params.id);
        detail.value = res.data;
        if (detail.value) {
          document.documentElement.setAttribute("lang", detail.value.locale || t("common.lang"));
          document.title = detail.value.title || t("meta.title");
          updateMetaTag("description", detail.value.description || t("meta.description"));
          updateMetaTag("keywords", detail.value.keywords || t("meta.keywords"));
        }
      } catch (error) {
        console.error("获取写作技巧详情失败：", error);
      }
    });
  }

  // 更新 `<meta>` 标签的函数
  function updateMetaTag(name, content) {
    let metaTag = document.querySelector(`meta[name="${name}"]`);
    if (!metaTag) {
      metaTag = document.createElement("meta");
      metaTag.setAttribute("name", name);
      document.head.appendChild(metaTag);
    }
    metaTag.setAttribute("content", content);
  }
</script>

<style lang="less" scoped>
  /* PC 端保持不变 */
  .page {
    width: 80%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    background-color: #fff;
  }

  /* 返回按钮 */
  .back {
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 18px;
    gap: 8px;
    padding: 10px 0;
  }

  .back img {
    width: 24px;
    height: 24px;
  }

  /* 标题 */
  .title {
    font-size: 28px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 20px;
    background: #3870ff;
    color: #fff;
    padding: 12px;
    border-radius: 10px;
  }

  /* 文本内容 */
  .text {
    font-size: 16px;
    line-height: 1.6;
    color: #333;
  }

  /* 适配移动端 */
  @media screen and (max-width: 768px) {
    .page {
      width: 100%;
      padding: 15px;
    }

    .back {
      font-size: 16px;
      padding: 15px 0;
    }

    .back img {
      width: 28px;
      height: 28px;
    }

    .title {
      font-size: 22px;
      padding: 8px;
    }

    .text {
      font-size: 14px;
      line-height: 1.8;
    }
  }
</style>
